<button
  [class]="buttonParams.class"
  [disabled]="buttonParams.disabled"
  (click)="buttonParams.click()"
  *ngIf="getButtonParams() as buttonParams"
>
  <div *ngIf="service.isLoadingState" class="rs-btn-waiting-dots"></div>
  <span *ngIf="!service.isLoadingState"
    >{{ buttonParams.labelKey | translate }}
  </span>
  <i
    *ngIf="buttonParams.showRightIcon"
    class="rs-icon-btn-third rs-margin-left1"
    aria-hidden="true"
  ></i>
</button>
